import React from 'react';
import { AnimatedSection } from '../components/ui/AnimatedSection';
import { SectionHeading } from '../components/ui/SectionHeading';
import { Button } from '../components/ui/Button';
import { BookOpenIcon, DumbbellIcon, PenToolIcon, UsersIcon, FlameIcon } from 'lucide-react';
export function FaithFitness() {
  const features = [{
    icon: BookOpenIcon,
    title: 'Daily Devotionals',
    desc: 'Scripture-based reflections connecting physical discipline with spiritual growth.'
  }, {
    icon: DumbbellIcon,
    title: 'Strength Workouts',
    desc: 'Structured, scalable 30-day training program for all fitness levels.'
  }, {
    icon: PenToolIcon,
    title: 'Journaling Prompts',
    desc: 'Daily exercises to recalibrate mindset and uncover limiting beliefs.'
  }, {
    icon: FlameIcon,
    title: 'Spiritual Growth',
    desc: 'Viewing health not as vanity, but as stewardship of the body God gave you.'
  }, {
    icon: UsersIcon,
    title: 'Community Accountability',
    desc: 'Designed to be done with your church small group or community.'
  }];
  return <main className="w-full pt-24" data-id="element-306">
      {/* Hero */}
      <section className="py-20 md:py-32 bg-dark relative border-b border-border overflow-hidden" data-id="element-307">
        <div className="absolute inset-0 z-0 opacity-40" data-id="element-308">
          <img src="https://images.unsplash.com/photo-1447452001602-7090c7ab2db3?q=80&w=2070" alt="Nature Light" className="w-full h-full object-cover" data-id="element-309" />
          <div className="absolute inset-0 bg-gradient-to-t from-dark via-dark/80 to-transparent" data-id="element-310"></div>
        </div>
        <div className="max-w-4xl mx-auto px-6 text-center relative z-10" data-id="element-311">
          <AnimatedSection data-id="element-312">
            <span className="text-gold text-sm font-medium uppercase tracking-[0.3em] mb-6 block" data-id="element-313">
              30-Day Body & Spirit Transformation
            </span>
            <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 font-heading leading-tight" data-id="element-314">
              Faith & Fitness Challenge
            </h1>
            <p className="text-xl text-muted leading-relaxed max-w-2xl mx-auto mb-10" data-id="element-315">
              Restore your body as a temple of the Holy Spirit. Align your
              physical health with biblical principles of discipline,
              stewardship, and purpose.
            </p>
            <Button href="https://holistic-health.bioshift.net/calender-booking" size="lg" data-id="element-316">
              Join the Challenge
            </Button>
          </AnimatedSection>
        </div>
      </section>

      {/* Scripture Section */}
      <section className="py-20 bg-surface border-b border-border" data-id="element-317">
        <div className="max-w-4xl mx-auto px-6 text-center" data-id="element-318">
          <AnimatedSection data-id="element-319">
            <p className="text-2xl md:text-3xl font-heading text-white italic leading-relaxed" data-id="element-320">
              "Do you not know that your bodies are temples of the Holy Spirit,
              who is in you, whom you have received from God? You are not your
              own; you were bought at a price. Therefore honor God with your
              bodies."
            </p>
            <p className="text-gold mt-6 font-medium tracking-widest uppercase text-sm" data-id="element-321">
              1 Corinthians 6:19-20
            </p>
          </AnimatedSection>
        </div>
      </section>

      {/* What's Included */}
      <section className="py-24 md:py-32 bg-dark" data-id="element-322">
        <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-323">
          <AnimatedSection data-id="element-324">
            <SectionHeading title="Program Elements" overline="What's Included" data-id="element-325" />
          </AnimatedSection>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mt-16" data-id="element-326">
            {features.map((item, i) => <AnimatedSection key={i} delay={i * 0.1} data-id="element-327">
                <div className="bg-surface border border-border p-8 h-full hover:border-gold/30 transition-colors text-center flex flex-col items-center" data-id="element-328">
                  <item.icon className="w-10 h-10 text-gold mb-6" data-id="element-329" />
                  <h3 className="text-xl font-bold text-white mb-3" data-id="element-330">
                    {item.title}
                  </h3>
                  <p className="text-muted text-sm leading-relaxed" data-id="element-331">
                    {item.desc}
                  </p>
                </div>
              </AnimatedSection>)}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-24 bg-surface border-t border-border text-center" data-id="element-332">
        <AnimatedSection data-id="element-333">
          <h2 className="text-4xl font-bold text-white mb-8 font-heading" data-id="element-334">
            Start Your 30-Day Reset
          </h2>
          <Button href="https://holistic-health.bioshift.net/calender-booking" size="lg" data-id="element-335">
            Apply Now
          </Button>
        </AnimatedSection>
      </section>
    </main>;
}